import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ListGroupTask } from '@shared/modules/list/model/list-group-task.model';

export interface ListTasksProcessInsertEvent {
  group: ListGroupTask;
  insertIndex: number;
  type: 'task' | 'message';
}

@Injectable()
export class ListTasksProcessInsertBus {
  private readonly insertSelectedSubject = new Subject<ListTasksProcessInsertEvent>();

  readonly insertSelected$ = this.insertSelectedSubject.asObservable();

  emit(event: ListTasksProcessInsertEvent): void {
    this.insertSelectedSubject.next(event);
  }
}
